import React, { useCallback, useEffect, useState } from "react";
import { Box, Collapse, Fade } from "@mui/material";
import IntlMessage from "app/components/Intl/IntlMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusSquare, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { isNil } from "app/utils";
import { FormLabelStyled, IconButtonStyled, LinearProgressStyled } from "./CollapsableSection.styles";
const CollapsableSection = ({
  header,
  children,
  hidden = false,
  onExpand = null,
  expanded = false,
  loading = false,
  controllable = false,
  disabled = false
}) => {
  const isExpandable = !isNil(expanded);
  const initialState = isExpandable ? expanded : true;
  const [visible, setVisible] = useState(initialState);
  useEffect(() => {
    setVisible(initialState);
  }, [initialState]);
  const onClick = useCallback(
    (e) => {
      e.stopPropagation();
      const newState = !visible;
      setVisible(newState);
      onExpand && onExpand({ expanded: visible });
    },
    [onExpand, visible]
  );
  return /* @__PURE__ */ React.createElement(Fade, { in: !hidden }, /* @__PURE__ */ React.createElement(Box, null, header && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormLabelStyled, { disabled }, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(IntlMessage, { value: header })), !controllable && isExpandable && /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(IconButtonStyled, { size: "large", color: "primary", onClick, disabled: loading || disabled }, visible ? /* @__PURE__ */ React.createElement(FontAwesomeIcon, { icon: faMinusSquare }) : /* @__PURE__ */ React.createElement(FontAwesomeIcon, { icon: faPlusSquare })))), /* @__PURE__ */ React.createElement(LinearProgressStyled, { variant: loading ? "indeterminate" : "determinate", value: 100 })), /* @__PURE__ */ React.createElement(Collapse, { in: visible }, children)));
};
export default CollapsableSection;
